// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import registerSW from "./registerSW";

// ✅ App Check debug token (DEV ONLY)
// In production: DO NOT set a debug token.
if (process.env.NODE_ENV !== "production") {
  // Only allow debug token on localhost-like hosts
  const host = window.location.hostname;
  const isLocal =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    host.endsWith(".local");

  if (isLocal) {
    // Provide the debug token via env or localStorage (never hardcode it in git)
    const envToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    const lsToken = localStorage.getItem("firebase-appcheck-debug-token");
    const token = envToken || lsToken;

    if (token) {
      // eslint-disable-next-line no-undef
      self.FIREBASE_APPCHECK_DEBUG_TOKEN = token;
      console.log("✅ App Check Debug Token enabled (DEV).");
    } else {
      console.log(
        "ℹ️ No App Check debug token found. Set REACT_APP_APPCHECK_DEBUG_TOKEN or localStorage key 'firebase-appcheck-debug-token'."
      );
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerSW();
